import { ActiveSubscriptionsList } from "@/components/account/ActiveSubscriptionsList";
import { SubscriptionHistoryCard } from "@/components/account/SubscriptionHistoryCard";
import { InvoicesCard } from "@/components/account/InvoicesCard";
import { PaymentMethodsCard } from "@/components/account/PaymentMethodsCard";

export function BillingPage() {
  return (
    <div className="space-y-5 sm:space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">Billing</h1>
        <p className="mt-1 text-sm text-muted-foreground sm:text-base">
          Every plan you're paying for, your charges, and past subscriptions.
        </p>
      </div>

      <ActiveSubscriptionsList />
      <PaymentMethodsCard />
      <InvoicesCard />
      <SubscriptionHistoryCard />
    </div>
  );
}
